import React from "react";
import { useSearchBar } from "../../Pregrine/SearchBar";
import classes from "./searchBar.module.css";
import { Search as SearchIcon } from "react-feather";
import Autocomplete from "./autocomplete/autocomplete";
import { FaTimes } from "react-icons/fa";

const SearchBar = React.forwardRef((props, ref) => {
  const { isOpen } = props;
  const talonProps = useSearchBar();
  const {
    containerRef,
    handleChange,
    handleFocus,
    handleSubmit,
    isAutoCompleteOpen,
    setIsAutoCompleteOpen,
    valid,
    isSubmitted,
    searchText,
    handleClear,
  } = talonProps;

  const rootClassName = isOpen ? classes.root_open : classes.root;

  return (
    <>
      <div className={rootClassName} ref={ref}>
        <div ref={containerRef} className={classes.container}>
          <form
            autoComplete="off"
            className={classes.form}
            onSubmit={handleSubmit}
          >
            <div className={classes.autocomplete}>
              <Autocomplete
                setVisible={setIsAutoCompleteOpen}
                valid={valid}
                visible={isAutoCompleteOpen}
                isSubmitted={isSubmitted}
                searchText={searchText}
              />
            </div>
            {isOpen ? (
              <div className={classes.search}>
                <div className={classes.inputWrapper}>
                  <input
                    type="text"
                    placeholder="I'm searching for..."
                    onChange={handleChange}
                    onFocus={handleFocus}
                    value={searchText}
                  />
                  <div className={classes.cancelBtn}>
                    {searchText && (
                      <FaTimes
                        size={15}
                        className={classes.clearButton}
                        onClick={handleClear}
                      />
                    )}
                  </div>
                </div>

                <div className={classes.searchSubmit}>
                  <button aria-label="Submit" type="submit">
                    <SearchIcon size={20} />
                  </button>
                </div>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    </>
  );
});

export default SearchBar;
